module.exports = __webpack_public_path__ + "img/firstN.b4cbf6ee.png";